module.exports = __webpack_public_path__ + "img/voucher_bg.1edb35ad.png";